/*
 * Scenario: rewrite-with-formats
 *
 * Wie rewrite-single, aber der Vorschlag kommt mit echten Format-Feldern
 * (Heading 2, fettes Wort, Section-Link auf die aktuelle Section). Browser-
 * Test-Anker fuer den Format-faehigen Composite-Renderer (Eintrag
 * "Delta-Review: Format-faehiger Composite-Renderer" im changelog vom
 * 2026-05-02).
 *
 * Erwartung im Browser:
 *   - Composite-Line wechselt live in H2-Groesse + Bold-Floor (WYSIWYG-Toggle)
 *   - Bold-Span auf "stuermische" wird im Add-Bereich fett gerendert
 *   - [[@sep]]-Marker wird zu Klartext-Label aufgeloest
 *   - Toggle T schaltet zwischen Original und Vorschlag
 */

import { emit, wait, resolve, payloadFromMarkdown } from './_helpers.js'

export const name = 'rewrite-with-formats'
export const description = 'Rewrite with heading, bold and a section link (composite renderer demo).'

export async function run(state) {
    const toolCallId = 'tu_rwf_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-rewrite-with-formats' }, 0)
    await emit(state, 'thinking', { text: 'Sharpening the heading and adding a back-link…' }, 300)
    await emit(state, 'thinkingDone', {}, 200)
    await emit(state, 'toolCall', { toolCallId: 'tu_read_1', tool: 'read_section', input: {} }, 150)
    await emit(state, 'toolResult', { toolCallId: 'tu_read_1', tool: 'read_section', summary: 'section read' }, 200)

    const paragraphId = resolve(state, '$cursor.paragraphId')
    const originalText = resolve(state, '$cursor.text')
    const baseVersion = resolve(state, '$cursor.version')
    const sepId = resolve(state, '$cursor.separatorId')

    // Markdown-Quelle: Heading-2 + fettes Wort + Section-Link auf die aktuelle Section.
    // resolve() gibt bei fehlendem separatorId den Placeholder-String
    // '$cursor.separatorId' zurueck — den filtern wir explizit raus, sonst
    // landet er als Link-Target im Markdown.
    const hasSepId = (typeof sepId === 'number')
        || (typeof sepId === 'string' && !sepId.startsWith('$'))
    const markdown = hasSepId
        ? `## Die **stuermische** Nacht [[@${sepId}]]`
        : '## Die **stuermische** Nacht'

    const patch = payloadFromMarkdown(markdown, 'text')

    await emit(state, 'proposeRewrite', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        originalText: typeof originalText === 'string' ? originalText : '(paragraph text here)',
        newText: patch.text,
        newFormats: patch.formats,
        newLinks: patch.links,
        newHeadingLevel: patch.headingLevel,
        newListType: patch.listType,
        newListLevel: patch.listLevel,
        newBlockquote: patch.blockquote,
        reason: 'Heading + bold + back-link to this section.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Heading is in. Want me to look at the next paragraph?'
            : info.result === 'version_mismatch'
                ? 'Paragraph was changed in the meantime — I will re-read and try again.'
                : 'Okay, I left the original heading. Anything else to try?'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
